module.exports = __webpack_public_path__ + "assets/c5db2037e6fd7d92837e54f8dda0fee8.svg";